import React from "react";
import AppFrame from "../../components/AppFrame";
import Page from "../../components/Page";

export default function NotFoundPage() {
  return (
    <AppFrame>
      <Page name="not-found">
        <h1>Not found!</h1>
      </Page>
    </AppFrame>
  );
}
